export default {"src":"/_next/static/media/file.3f8e955a.svg","height":21,"width":17};